import {useTranslation} from 'react-i18next'
import {MenuItem} from './MenuItem'
import {useAuth} from '../../../../../app/modules/auth'
import {MenuInnerWithSub} from './MenuInnerWithSub'
import {useAppDispatch, useAppSelector} from '../../../../../redux/hooks'
import {UserMsgCount} from '../../../../../redux/Slice/chatSlice'
import {useCallback, useEffect} from 'react'

export function AdminMenu() {
  const {t} = useTranslation()
  const {hasPermission} = useAuth()
  const dispatch = useAppDispatch()
  const {msgCount} = useAppSelector((state) => state.chat)

  const fetchMessageCount = useCallback(() => {
    dispatch(UserMsgCount())
  }, [dispatch])

  useEffect(() => {
    fetchMessageCount()
  }, [fetchMessageCount])

  return (
    <>
      {/*  student menu */}
      {hasPermission('membership-list') && (
        <MenuInnerWithSub
          title={t('LABEL.MEMBERSHIP')}
          to=''
          menuPlacement='bottom-end'
          menuTrigger='click'
          hasArrow={true}
          fontIcon=''
        >
          {hasPermission('membership-list') && (
            <MenuItem
              to='/admin/memberships'
              fontIcon='fa fa-users text-white mx-2'
              title={t('LABEL.MEMBERSHIP')}
            />
          )}
        </MenuInnerWithSub>
      )}

      {/* ADMINISTRATION MENU */}
      {(hasPermission('users-list') ||
        hasPermission('roles-list') ||
        hasPermission('sections-list')) && (
        <MenuInnerWithSub
          title={t('MENU.ADMINISTRATION')}
          to=''
          menuPlacement='bottom-start'
          menuTrigger='click'
          hasArrow={true}
        >
          {/* users */}
          {(hasPermission('users-list') || hasPermission('roles-list')) && (
            <MenuInnerWithSub
              title={t('MENU.USERS')}
              to=''
              fontIcon='fa fa-users'
              hasArrow={true}
              menuPlacement='right-start'
              menuTrigger={`{default:'click', lg: 'hover'}`}
            >
              {hasPermission('users-list') && (
                <MenuItem
                  to='/users'
                  fontIcon='fa fa-users text-white mx-2'
                  title={t('MENU.USERS')}
                />
              )}
              {hasPermission('roles-list') && (
                <MenuItem
                  to='/roles-list'
                  fontIcon='fa fa-lock-open text-white'
                  title={t('MENU.ROLES')}
                />
              )}
            </MenuInnerWithSub>
          )}
          {/* tools */}
          {(hasPermission('sections-list') ||
            hasPermission('academic-years-list') ||
            hasPermission('program-years-list') ||
            hasPermission('program-levels-list') ||
            hasPermission('semesters-list') ||
            hasPermission('organizations-list') ||
            hasPermission('countries-list') ||
            hasPermission('currencies-list') ||
            hasPermission('video-categories-list')) && (
            <MenuInnerWithSub
              title={t('MENU.TOOLS')}
              to=''
              fontIcon='fa fa-tools'
              hasArrow={true}
              menuPlacement='right-start'
              menuTrigger={`{default:'click', lg: 'hover'}`}
            >
              {hasPermission('organizations-list') && (
                <MenuItem
                  to='/finance/organizations-list'
                  fontIcon='fa fa-building-columns text-white mx-2'
                  title={t('MENU.ORGANIZATIONS')}
                />
              )}
              {hasPermission('sections-list') && (
                <MenuItem
                  to='/tools/sections-list'
                  fontIcon='fa fa-layer-group text-white mx-2'
                  title={t('MENU.SECTIONS')}
                />
              )}
              {hasPermission('academic-years-list') && (
                <MenuItem
                  to='/tools/academic-years-list'
                  fontIcon='fa fa-hourglass-half text-white'
                  title={t('MENU.ACADEMIC_YEARS')}
                />
              )}
              <MenuItem
                to='/tools/time-slots'
                fontIcon='fa fa-clock text-white'
                title={t('LABEL.TIME_SLOTS')}
              />
              <MenuItem
                to='/tools/classes'
                fontIcon='fa fa-chalkboard text-white'
                title={t('LABEL.CLASS')}
              />
              <MenuItem
                to='/tools/exam-classes'
                fontIcon='fa fa-clipboard-question text-white'
                title={t('LABEL.EXAM_CLASS')}
              />
              {hasPermission('program-years-list') && (
                <MenuItem
                  to='/tools/program-years-list'
                  fontIcon='fa fa-list text-white'
                  title={t('MENU.PROGRAM_YEARS')}
                />
              )}
              {hasPermission('program-levels-list') && (
                <MenuItem
                  to='/tools/program-levels-list'
                  fontIcon='fa fa-user-graduate text-white'
                  title={t('MENU.PROGRAM_LEVELS')}
                />
              )}
              {hasPermission('semesters-list') && (
                <MenuItem
                  to='/tools/semesters-list'
                  fontIcon='fa fa-columns text-white'
                  title={t('MENU.SEMESTERS')}
                />
              )}
              {hasPermission('countries-list') && (
                <MenuItem
                  to='/tools/countries-list'
                  fontIcon='fa fa-globe text-white'
                  title={t('MENU.COUNTRIES')}
                />
              )}
              {hasPermission('currencies-list') && (
                <MenuItem
                  to='/tools/currencies-list'
                  fontIcon='fa fa-coins text-white mx-2'
                  title={t('MENU.CURRENCIES')}
                />
              )}
              {hasPermission('video-categories-list') && (
                <MenuItem
                  to='/tools/video-categories-list'
                  fontIcon='fa fa-film text-white'
                  title={t('MENU.VIDEO_CATEGORIES')}
                />
              )}
            </MenuInnerWithSub>
          )}
        </MenuInnerWithSub>
      )}
      {/* END OF ADMINISTRATION MENU */}

      {/* <MenuItem
        to='/chat/ad-chat-room'
        title={
          <span className='position-relative'>
            {t('LABEL.CHAT')}
            <span className='badge badge-circle bg-danger position-absolute top-0 text-white translate-middle'>
              {msgCount}
            </span>
          </span>
        }
      /> */}
    </>
  )
}
